import { render, staticRenderFns } from "./TheLayoutFooter.vue?vue&type=template&id=01645c5d&scoped=true"
import script from "./TheLayoutFooter.vue?vue&type=script&lang=js"
export * from "./TheLayoutFooter.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutFooter.vue?vue&type=style&index=0&id=01645c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01645c5d",
  null
  
)

export default component.exports